import React from 'react';
import { BiEdit, BiPlus, BiTime, BiTrash } from 'react-icons/bi';

import Bouton from '../../UI/Bouton/Bouton';
import TaskBuilder from '../TaskBuilder/TaskBuilder';

import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import S from '../ProfilTasks/ProfilTasks.module.scss';

const TaskProfil = ({ task, onEdit, onDelete, onAddFunction }) => {
  if (!task || !task.id) {
    return (
      <div className={S.emptyState}>
        <h3>Aucune tâche sélectionnée</h3>
        <p>Sélectionnez une tâche dans le tableau pour voir les détails.</p>
      </div>
    );
  }

  return (
    <div className={S.profilContainer}>
      <div className={S.header}>
        <div className={S.headerInfo}>
          <div className={S.functionIcon}>
            <BiTime size={22} color="#fff" />
          </div>
          <div className={S.functionTitle}>
            <h2 className={S.functionName}>{task.nom}</h2>
            <div className={S.functionMeta}>
              <span className={S.typeBadge}>
                {task.active ? 'Active' : 'Inactive'}
              </span>
              <span className={S.functionId}>ID: {task.id}</span>
            </div>
          </div>
        </div>
        <div className={S.headerActions}>
          <Bouton
            type={type_btn.success}
            rond={true}
            taille="small"
            cliquer={onAddFunction}
            className={S.actionBtn}
          >
            <BiPlus size={16} />
          </Bouton>
          <Bouton
            type={type_btn.secondary}
            rond={true}
            taille="small"
            cliquer={onEdit}
            className={S.actionBtn}
          >
            <BiEdit size={16} />
          </Bouton>
          <Bouton
            type={type_btn.danger}
            rond={true}
            taille="small"
            cliquer={onDelete}
            className={S.actionBtn}
          >
            <BiTrash size={16} />
          </Bouton>
        </div>
      </div>

      <div className={S.tabContent}>
        <TaskBuilder
          initialTask={task}
          isEditMode={true}
          readOnly={true}
          annuler={() => {}}
          sauvegarderTache={() => {}}
        />
      </div>
    </div>
  );
};

export default TaskProfil;
